import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { colors, radii, spacing, typography } from '../../core/theme/tokens';

type SampleDataBannerProps = {
  /** Tighter padding (e.g. Settings). Copy stays the same. */
  compact?: boolean;
};

/**
 * Guest / sample-mode note. Sign-in lives in the Explore header —
 * do not open Auth from this banner so people can browse first.
 */
export function SampleDataBanner({ compact = false }: SampleDataBannerProps) {
  return (
    <View style={[styles.note, compact && styles.noteCompact]}>
      <Text style={styles.eyebrow}>Sample preview</Text>
      <Text style={styles.message}>
        Example numbers so you can look around. Sign in when you want to upload your own
        statements.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  note: {
    backgroundColor: 'rgba(61, 214, 164, 0.08)',
    borderColor: 'rgba(61, 214, 164, 0.22)',
    borderWidth: 1,
    borderRadius: radii.md,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    gap: 4,
    zIndex: 1,
  },
  noteCompact: {
    paddingVertical: spacing.xs,
  },
  eyebrow: {
    ...typography.label,
    color: colors.accent,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  message: {
    ...typography.caption,
    color: colors.text,
    lineHeight: 18,
  },
});
